import type { ViewerClientSpecMap, ViewerServiceData } from '@wix/thunderbolt-symbols'
import { keyBy } from 'lodash'

export const VIEWER_SERVICE_EXTENSION_NAME = 'VIEWER_SERVICE'

export const resolveRequiredServices = (
	clientSpecMap: ViewerClientSpecMap,
	builderComponentsInStructure: Set<string>
): Record<string, boolean> => {
	const viewerServices = Object.values(clientSpecMap).flatMap(
		(maybeViewerAppSpecData) =>
			maybeViewerAppSpecData.components
				?.filter((maybeService) => maybeService.type === VIEWER_SERVICE_EXTENSION_NAME)
				.map((service) => (service.data as unknown) as ViewerServiceData) || []
	)
	const viewerServicesMap = keyBy(viewerServices, (viewerService: ViewerServiceData) => viewerService.package_name)

	// Process all apps in the client spec map
	const filteredBuilderComponents = Object.values(clientSpecMap).flatMap(
		(appSpecData) =>
			appSpecData.components?.filter((component) => builderComponentsInStructure.has(component.data.type)) || []
	)

	const requiredServicesMap: Record<string, boolean> = {}

	const firstLevelDependencyServices = new Set<string>(
		filteredBuilderComponents.flatMap((component) => component.data.serviceDependencies || []) ?? []
	)

	const dfs = (servicePackageName: string) => {
		if (servicePackageName in requiredServicesMap) {
			return
		}
		const service = viewerServicesMap[servicePackageName]
		if (service) {
			requiredServicesMap[servicePackageName] = true
			service.viewer.dependencies?.forEach((dependency) => {
				dfs(dependency)
			})
		}
	}

	firstLevelDependencyServices.forEach((service) => {
		dfs(service)
	})

	return requiredServicesMap
}
